(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();
(function (Router, Controller, Service, View, Helper, Model, $, Config) {
    'use strict';

    Router.handle = function () {
        
        Router.UpdateVaribales();

        var combo = Model.Window.combo;
        var modo = Model.Window.modo;
        
        switch (modo) {
            case 'S':
                View.wallSuscribime();
                break;
            case 'P':
                // Obtengo el codigo de validacion desde la URL y la guardo en Model.pin
                Model.updatePinFromUrl();
                // pantalla de activacion de pines
                View.validarPin(null, function () {
                    // Si viene desde login, hago el proceso de validacion automaticamente.
                    if (Model.getAction() == 'vp') {
                        Controller.validarPinesProcesar();
                    }
                });
                break;
            case 'C':
                Service.isLogged(function () {
                     Controller.flowB({
                            combo: combo
                      });
                }, function () {
                    if (combo == Config.COMBO_BONIFICADO) {
                        Helper.redirectToLoginWCombo(combo, Config.dominioIngresarDefault);
                    } else {
                        Helper.redirectToLogin(Model.Window.originForCallback);
                    }
                });
                break;
            case 'T':
                View.procesarPago();              
                break;
            case 'D':
                if (Model.Window.landingUrl != null) {
                    View.wallDinamico();
                }
                break;
            case 'PF':
                View.wallPromoVencida();
                break;
            default:
                throw new Error("No existe la pagina solicitada");
        }
    }
    
    Router.UpdateVaribales = function () {
        Model.updateAccesoWindowModel();
        Router.MapUrl(Model.Window.modo);
        Model.updateCanalDeVenta(Model.Window.modo);
    }

    Router.MapContact = function (route) {
        if (!Model.Window.contact) {
            // el fc que viene en la url lo seteo en el Model.Window.contact de updateAccesoWindowModel
            //si no tiene fc seteado en la url, levanto el de la pagina correspondiente, o uno default
            if (route.formaContacto)
                Model.Window.contact = route.formaContacto
        }
    }
    //siempre tiene prioridad el seteado en la url(que esta en el model)
    Router.MapProductCategory = function (route) {
        if (!Model.productCategory) {
             if (route.productCategory)
                Model.productCategory = route.productCategory
        }rdffv 
    }

    // ingresar.lanacion.com.ar/{path}/{modo}/{combo}/{sitioId}
    Router.MapUrl = function (modo) {

        var route;
        var encontro = false;
        var path = Helper.getURLPath();
        try {
            for (route in Config.Routes) {
                route = Config.Routes[route];
                //console.log(route);
                if (path === route.path) {
                    if (route.validaModo == null || !route.validaModo || (route.modo === modo)) {
                        Model.Window.modo = route.modo;
                        Model.Window.source = route.source;
                        encontro = true;
                        Router.MapContact(route);
                        Router.MapProductCategory(route);
                        break;
                    }
                }
            }
        } catch (ex) {
            logger && logger.error('MapUrl | Error (' + modo + ')', ex);
        }

        if (!encontro){
            logger && logger.error('MapUrl | No existe el modo', { "modo": modo, "path" : path });
            throw new Error("No existe el modo");
        }
        
 
    }

    
})(LN.Router, LN.Controller, LN.Service, LN.View, LN.Helper, LN.Model, jQuery, LN.Config);



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/router.js